// extracted by mini-css-extract-plugin
module.exports = {"info":"OrderInfo_info__vKAuD","description":"OrderInfo_description__4tam0"};